module.exports = __webpack_public_path__ + "img/tx5.5c65f62d.png";